import { InquiryFileStatus } from '@/types/chat/chat';

export const isInquiryFileProcessingTerminal = (
  status: InquiryFileStatus['status'],
) => status === 'finished_processing' || status === 'failed';

export const hasInProgressInquiryFiles = (
  files: InquiryFileStatus[],
): boolean => files.some(file => !isInquiryFileProcessingTerminal(file.status));

export const shouldBlockSendForProcessingFiles = (
  chatMode: string,
  files: InquiryFileStatus[],
  filesLoading: boolean,
): boolean => {
  if (chatMode === 'chat_only') {
    return false;
  }

  return filesLoading || hasInProgressInquiryFiles(files);
};

export const INQUIRY_FILES_POLL_INTERVAL = 30000;

/** The ids of the finished files, sorted: changes when one finishes or leaves. */
export const finishedFilesKey = (files: InquiryFileStatus[]): string =>
  files
    .filter(file => file.status === 'finished_processing')
    .map(file => String(file.id))
    .sort()
    .join(',');

/**
 * After a files-status answer: poll again while a file is not terminal,
 * and once more after the set of finished files changed, so the
 * comparison totals the inquiry reload brings in are confirmed.
 */
export const shouldPollInquiryFilesAgain = (
  files: InquiryFileStatus[],
  previousFinishedKey: string,
): boolean =>
  hasInProgressInquiryFiles(files) ||
  finishedFilesKey(files) !== previousFinishedKey;
